import { taggedTemplateLiteral as _taggedTemplateLiteral, slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import React, { memo, useState } from 'react';
import _Icon from '../../components/Icon/index.js';
import _Button from '../../components/Button/index.js';
import _Dropdown from '../Dropdown/index.js';

var _templateObject, _templateObject2;
var StyledDropdown = styled(_Dropdown)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-left: 1rem;\n\n  & div {\n    min-width: auto;\n  }\n"])));
var StyledPaginationContainer = styled('nav')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  text-align: center;\n  margin-bottom: 0.25rem;\n"])));
var ROWS_PER_PAGE_OPTIONS = [5, 10, 20, 25, 50, 100];
var PaginationDropdown = /*#__PURE__*/memo(function (_ref) {
  var rowsPerPage = _ref.rowsPerPage,
    setRowsPerPage = _ref.setRowsPerPage;
  var handleClick = function handleClick(row) {
    return function () {
      return setRowsPerPage(row);
    };
  };
  var dropdownItems = ROWS_PER_PAGE_OPTIONS.map(function (item) {
    return {
      onClick: handleClick(item),
      text: item.toString()
    };
  });
  return /*#__PURE__*/React.createElement(StyledDropdown, {
    dropdownItems: dropdownItems,
    buttonText: rowsPerPage.toString()
  });
});
var Paginator = function Paginator(_ref2) {
  var data = _ref2.data,
    _ref2$managed = _ref2.managed,
    managed = _ref2$managed === void 0 ? true : _ref2$managed,
    _ref2$initialPage = _ref2.initialPage,
    initialPage = _ref2$initialPage === void 0 ? 0 : _ref2$initialPage,
    _ref2$initialRowsPerP = _ref2.initialRowsPerPage,
    initialRowsPerPage = _ref2$initialRowsPerP === void 0 ? 10 : _ref2$initialRowsPerP,
    _ref2$rowsPerPage = _ref2.rowsPerPage,
    rowsPerPageProp = _ref2$rowsPerPage === void 0 ? initialRowsPerPage : _ref2$rowsPerPage,
    _ref2$currentPage = _ref2.currentPage,
    currentPageProp = _ref2$currentPage === void 0 ? initialPage : _ref2$currentPage,
    _ref2$renderContent = _ref2.renderContent,
    RenderContent = _ref2$renderContent === void 0 ? function () {
      return null;
    } : _ref2$renderContent,
    _ref2$setRowsPerPage = _ref2.setRowsPerPage,
    setRowsPerPageProp = _ref2$setRowsPerPage === void 0 ? function () {
      return null;
    } : _ref2$setRowsPerPage,
    _ref2$setCurrentPage = _ref2.setCurrentPage,
    setCurrentPageProp = _ref2$setCurrentPage === void 0 ? function () {
      return null;
    } : _ref2$setCurrentPage;
  // All this might be a candidate for a hook someday
  var rowsPerPage;
  var currentPage;
  var setRowsPerPage;
  var setCurrentPage;
  // If managed, manage the state for the consumer
  if (managed) {
    var _useState = useState(initialRowsPerPage);
    var _useState2 = _slicedToArray(_useState, 2);
    rowsPerPage = _useState2[0];
    setRowsPerPage = _useState2[1];
    var _useState3 = useState(initialPage);
    var _useState4 = _slicedToArray(_useState3, 2);
    currentPage = _useState4[0];
    setCurrentPage = _useState4[1];
  } else {
    rowsPerPage = rowsPerPageProp;
    setRowsPerPage = setRowsPerPageProp;
    currentPage = currentPageProp;
    setCurrentPage = setCurrentPageProp;
  }
  var extraPages;
  var totalPages;
  if (data.length < rowsPerPage) {
    extraPages = 0;
    totalPages = 1;
  } else {
    extraPages = data.length % rowsPerPage !== 0 ? 1 : 0;
    totalPages = Math.floor(data.length / rowsPerPage + extraPages);
  }
  var atLastPage = currentPage + 1 === totalPages;
  var atFirstPage = currentPage === 0;
  var startingIndex = currentPage * rowsPerPage;
  var endingIndex = startingIndex + rowsPerPage > data.length ? data.length : startingIndex + rowsPerPage;
  var pagedData = data.slice(startingIndex, endingIndex);
  var incrementPage = function incrementPage(e) {
    e.preventDefault();
    if (!atLastPage) {
      setCurrentPage(currentPage + 1);
    }
  };
  var decrementPage = function decrementPage(e) {
    e.preventDefault();
    if (!atFirstPage) {
      setCurrentPage(currentPage - 1);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RenderContent, {
    pagedData: pagedData
  }), /*#__PURE__*/React.createElement(StyledPaginationContainer, {
    "aria-label": 'pagination'
  }, /*#__PURE__*/React.createElement("span", null, "Rows per page:"), /*#__PURE__*/React.createElement(PaginationDropdown, {
    rowsPerPage: rowsPerPage,
    setRowsPerPage: setRowsPerPage
  }), /*#__PURE__*/React.createElement("span", {
    "data-testid": 'totalRows'
  }, startingIndex + 1, "-", endingIndex, " of ", data.length), /*#__PURE__*/React.createElement(_Button, {
    onClick: decrementPage,
    style: {
      marginLeft: '1.5rem'
    },
    size: 'small',
    disabled: atFirstPage,
    "aria-label": 'previous'
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: 'arrow-left',
    size: 'small',
    color: 'black'
  })), /*#__PURE__*/React.createElement(_Button, {
    onClick: incrementPage,
    size: 'small',
    disabled: atLastPage,
    "aria-label": 'next'
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: 'arrow-right',
    size: 'small',
    color: 'black'
  }))));
};
var Paginator$1 = /*#__PURE__*/memo(Paginator);

export default Paginator$1;
